import {Directive} from '@angular/core';

@Directive({
  selector: '[cfFamilyProductSubtitle]',
})
export class FamilyProductSubtitleDirective {

  constructor() {
  }

}
